import { render, staticRenderFns } from "./Stimulate.vue?vue&type=template&id=beed6490&scoped=true&"
import script from "./Stimulate.vue?vue&type=script&lang=js&"
export * from "./Stimulate.vue?vue&type=script&lang=js&"
import style0 from "./Stimulate.vue?vue&type=style&index=0&id=beed6490&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beed6490",
  null
  
)

export default component.exports